import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCheckMarkCircle12Filled(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconCheckMarkCircle12Filled"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#CheckMarkCircle12Filled)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12m2.934-6.967a.5.5 0 1 0-.707-.707L5.1 7.454 3.773 6.128a.5.5 0 0 0-.707.707l1.68 1.68.353.353.353-.353z"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="CheckMarkCircle12Filled">
                        <path fill="#fff" d="M0 0h12v12H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconCheckMarkCircle12Filled);
